import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import {
  PreferenceKey,
  usePreferences,
} from '../../../../../hooks/usePreferences';
import { LISTING_EDIT_RESTRICTED_DAYS } from '../types';

export const WarningEditState = ({
  onAccept,
  onDenied,
}: {
  onAccept: () => void;
  onDenied: () => void;
}) => {
  const { usePreference } = usePreferences();
  // Use the preferences hook for hiding the warning edit restriction
  const [hideWarningEditRestriction, setHideWarningEditRestriction] =
    usePreference<boolean>(PreferenceKey.HIDE_WARNING_EDIT_RESTRICTION, false);

  if (hideWarningEditRestriction) return null;

  return (
    <Dialog
      open
      onClose={() => {}}
      maxWidth={'sm'}
      fullWidth
      sx={{
        p: 2,
      }}
    >
      <DialogTitle
        color="error"
        sx={{
          textAlign: 'center',
        }}
      >
        This Listing Was Taken Off The Market
      </DialogTitle>
      <DialogContent>
        <Box sx={{ textAlign: 'center', p: 0 }}>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 0 }}>
            This Listing was taken off the market more than{' '}
            {LISTING_EDIT_RESTRICTED_DAYS} days ago and can no longer be edited.
            However as a Bright Customer Support user, you can make changes for
            the agent. Click Yes to proceed, or No to cancel.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          p: 2,
          justifyContent: 'space-evenly',
        }}
      >
        <Button
          color="primary"
          onClick={() => {
            setHideWarningEditRestriction(true);
            onAccept();
          }}
          variant="contained"
        >
          YES
        </Button>
        <Button
          onClick={() => {
            onDenied();
          }}
        >
          NO
        </Button>
      </DialogActions>
    </Dialog>
  );
};
